import {
    IDatiqNumberRange,
    IDatiqRateDateRange
} from './datiq-app.interface';

export const DATIQ_DEFAULT_EMPTY_LABEL: string = '--';
export const DATIQ_DEFAULT_EMPTY_LABEL_NA: string = 'n/a';
export const DATIQ_DEFAULT_STRING: string = '';
export const DATIQ_DEFAULT_BOOLEAN: boolean = false;
export const DATIQ_DEFAULT_NUMBER: number = -1;
export const DATIQ_DEFAULT_SEPERATOR: string = '-';
export const DATIQ_DEFAULT_LONGITUDE: number = -98.5795;
export const DATIQ_DEFAULT_LATITUDE: number = 39.8283;
export const DATIQ_DEFAULT_FLOAT: number = 0.0;
export const DATIQ_DEFAULT_DATE: Date = new Date();
export const DATIQ_DEFAULT_DATE_RANGE: IDatiqRateDateRange = {
    start: new Date(),
    end: new Date(),
};
export const DATIQ_DEFAULT_NUMBER_RANGE: IDatiqNumberRange = {
    start: DATIQ_DEFAULT_NUMBER,
    end: DATIQ_DEFAULT_NUMBER,
};
export const DATIQ_DEFAULT_FLOAT_STRING: string = '0.00';
export const DATIQ_DEFAULT_CURRENCY_STRING: string = '$0.00';
export const DATIQ_DEFAULT_ID: (prefix?: string) => string = (
    prefix?: string
) => `${!!prefix ? prefix + '-' : ''}${(Math.random() + 1).toString(36).substring(7)}`;
export const DATIQ_DEFAULT_ID_LONG: () => number = () =>
    Math.floor(Math.random() * (10000000 - 100 + 1) + 100);
export const DATIQ_DEFAULT_UUID: string = `xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'`;
export const DATIQ_DEFAULT_ARRAY: unknown[] = [];
export const DATIQ_FILE_UPLOAD_SIZE_LIMIT: Number = 10 * 1024 * 1024;
export const DATIQ_PARAMS_ID_SEPERATOR = `~`;
